<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { getInstitutionConfiguration, getInstitutionConfigurationTest, getInstitutionName, obtenerBitacora } from '@/components/utils/functions'
import { BitacoraData } from '@shared/types/base'
import CaracteristicasPlan from '@/components/finanzas/CaracteristicasPlan.vue'
import Payments from '@/components/finanzas/Payments.vue'
import Facturas from '@/components/finanzas/Facturas.vue'
// Store y datos
const store = useStore()
const idInstitution = computed(() => store.getters['global/currentInstitution'])

const institutionName = ref('')
const institutionConfiguration = ref<any>({})
const institutionConfigurationTest = ref<any>({})
const activeTab = ref('features')
const bitacora = ref<BitacoraData | null>(null)
const selectTab = (tab: string) => {
	if (activeTab.value === tab) return
	activeTab.value = tab
}

onMounted(async () => {
	institutionName.value = await getInstitutionName(idInstitution.value)
	institutionConfiguration.value = await getInstitutionConfiguration(idInstitution.value)
	institutionConfigurationTest.value = await getInstitutionConfigurationTest(idInstitution.value)
	bitacora.value = await obtenerBitacora(idInstitution.value)
})
watch(idInstitution, async (newId, oldId) => {
	if (newId !== oldId) {
		institutionName.value = await getInstitutionName(idInstitution.value)
		institutionConfiguration.value = await getInstitutionConfiguration(idInstitution.value)
		institutionConfigurationTest.value = await getInstitutionConfigurationTest(idInstitution.value)
		bitacora.value = await obtenerBitacora(idInstitution.value)
	}
})
</script>

<template>
	<div class="institution-page">
		<!-- Header -->
		<VaCard class="header-card" flat>
			<div class="header-content">
				<div class="header-title">
					<span class="institution-title">Información del contrato, pagos, notificaciones y facturas</span>
				</div>
			</div>
		</VaCard>

		<!-- Tabs Navigation -->
		<div class="tabs-container">
			<VaTabs v-model="activeTab" class="custom-tabs">
				<VaTab label="Características del plan" name="features" @click="selectTab('features')" />
				<VaTab label="Pago" name="payments" @click="selectTab('payments')" />
				<VaTab label="Facturas" name="facturas" @click="selectTab('facturas')" />
			</VaTabs>
		</div>

		<!-- Content Sections -->
		<VaCard v-if="activeTab === 'features'" class="content-section" flat>
			<CaracteristicasPlan :id-institution="idInstitution" :bitacora-data="bitacora" :current-institution="idInstitution" />
		</VaCard>
		<VaCard v-if="activeTab === 'payments'" class="content-section" flat>
			<Payments :id-institution="idInstitution" :bitacora-data="bitacora" :current-institution="idInstitution" />
		</VaCard>
		<VaCard v-if="activeTab === 'facturas'" class="content-section" flat>
			<Facturas :id-institution="idInstitution" />
		</VaCard>
	</div>
</template>

<style scoped>
.institution-page {
	background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
	min-height: 100vh;
	padding: 2rem;
	border-radius: 0;
}

.header-card {
	margin-bottom: 2rem;
	background: rgba(255, 255, 255, 0.95);
	backdrop-filter: blur(10px);
	border-radius: 20px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
	border: 1px solid rgba(255, 255, 255, 0.2);
	padding: 2rem;
}

.header-content {
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
}

.header-title {
	text-align: center;
}

.institution-title {
	font-size: 2.5rem;
	font-weight: 700;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tabs-container {
	margin-bottom: 2rem;
}

.custom-tabs {
	background: rgba(255, 255, 255, 0.95);
	backdrop-filter: blur(10px);
	border-radius: 16px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
	border: 1px solid rgba(255, 255, 255, 0.2);
	overflow: hidden;
}

.content-section {
	background: rgba(255, 255, 255, 0.95);
	backdrop-filter: blur(10px);
	border-radius: 20px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
	border: 1px solid rgba(255, 255, 255, 0.2);
	padding: 2rem;
}

/* Responsive Design */
@media (max-width: 1200px) {
	.institution-page {
		padding: 1.5rem;
	}
}

@media (max-width: 900px) {
	.institution-page {
		padding: 1rem;
	}

	.header-card {
		padding: 1.5rem;
	}

	.institution-title {
		font-size: 2rem;
	}

	.content-section {
		padding: 1.5rem;
	}
}

@media (max-width: 600px) {
	.institution-page {
		padding: 0.5rem;
	}

	.header-card {
		padding: 1rem;
		margin-bottom: 1rem;
	}

	.institution-title {
		font-size: 1.5rem;
	}

	.content-section {
		padding: 1rem;
	}
}
</style>
